import type { SystemUi } from "@core/registry";
import { EquipmentStep } from "./EquipmentStep";
import { ExperienceStep } from "./ExperienceStep";
import { FinishingStep } from "./FinishingStep";
import { FreePointsStep } from "./FreePointsStep";
import { GroupCard } from "./group";
import { ModuleStep } from "./ModuleStep";
import { MoonSignStep } from "./MoonSignStep";
import { AdvanceTab, DescriptionTab, EquipmentTab, MagicTab, OverviewTab, PlayPanel, SkillsTab } from "./sheet";
import { AttributesStep, IdeaStep, RaceStep } from "./steps";
import "./splittermond.css";

/** Steps whose component shows every open choice of the step itself. */
const selfContainedSteps = new Set(["kultur", "abstammung", "ausbildung", "feinschliff"]);

export const splittermondUi: SystemUi = {
  id: "splittermond",
  wizardSteps: {
    idee: IdeaStep,
    rasse: RaceStep,
    kultur: ModuleStep,
    abstammung: ModuleStep,
    ausbildung: ModuleStep,
    attribute: AttributesStep,
    staerken: FreePointsStep,
    mondzeichen: MoonSignStep,
    erfahrung: ExperienceStep,
    feinschliff: FinishingStep,
    ausruestung: EquipmentStep,
  },
  sheetTabs: [
    { id: "uebersicht", label: "Übersicht", component: OverviewTab },
    { id: "fertigkeiten", label: "Fertigkeiten", component: SkillsTab },
    { id: "magie", label: "Magie", component: MagicTab },
    { id: "ausruestung", label: "Ausrüstung", component: EquipmentTab },
    { id: "beschreibung", label: "Beschreibung", component: DescriptionTab },
    { id: "steigern", label: "Steigern", component: AdvanceTab, modes: ["career"] },
  ],
  playPanel: PlayPanel,
  groupCard: GroupCard,
  handlesChoice: (choice) => choice.id === "rasse.race" || choice.id === "mondzeichen.id" || (!!choice.step && selfContainedSteps.has(choice.step)),
};
